import {
  globalHumanReadableRender,
  IAttributeOperator, IBetweenValues, ICrmEntityAttributeTypeToOperatorsHash, IOperatorsHash,
  wrapWithProtectionConditionForNegationString,
  wrapWithProtectionConditionForString
} from './crm-entities-base-operators';
import { IAttributeOption, CrmEntityTypeEnum } from '../../crm-entities/crm-entities.model';
import { TranslateService } from '@ngx-translate/core';
import { NumberOperatorDifferent, NumberOperatorEquals, NumberOperatorGreaterThan,
  NumberOperatorGreaterThanEqual, NumberOperatorLessThan, NumberOperatorLessThanEqual } from './crm-entities-number-operators';
import {
  DateOnlyOperatorBetween, DateOnlyOperatorDifferent, DateOnlyOperatorEquals, DateOnlyOperatorGreaterOrEqualTo, DateOnlyOperatorGreaterThan,
  DateOnlyOperatorLessThan, DateOnlyOperatorLessThanEqual, DateTimeOperatorBetween, DateTimeOperatorDifferent, DateTimeOperatorEquals,
  DateTimeOperatorGreaterOrEqualTo, DateTimeOperatorGreaterThan, DateTimeOperatorLessThan, DateTimeOperatorLessThanEqual
} from './crm-entities-date-operators';
import { ILookupData } from '../../lookup-dialog-component';


export { IAttributeOperator, IBetweenValues } from './crm-entities-base-operators';

export let CrmEntityAttributeOperators: IOperatorsHash = {
  'equalsNumber': new NumberOperatorEquals(),
  'differentNumber': new NumberOperatorDifferent(),
  'lessThanNumber': new NumberOperatorLessThan(),
  'lessOrEqualToNumber': new NumberOperatorLessThanEqual(),
  'greaterThanNumber': new NumberOperatorGreaterThan(),
  'greaterOrEqualThanNumber': new NumberOperatorGreaterThanEqual(),

  /***********************
   ** Strings Operators **
   ***********************/
  'equalsString': {
    name: 'equalsString',
    displayNameKey: 'COMMON.CRM_ENTITY_OPERATORS.EQUALS',
    humanReadableTranslationKey: 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.EQUALS',
    renderFreeMarker(left: string, right: string) {
      return `${wrapWithProtectionConditionForString(left)} && (${left} == "${right}")`;
    },
    renderHumanReadable: globalHumanReadableRender
  },

  'differentString': {
    name: 'differentString',
    displayNameKey: 'COMMON.CRM_ENTITY_OPERATORS.DIFFERENT',
    humanReadableTranslationKey: 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.DIFFERENT',
    renderFreeMarker(left: string, right: string) {
      return `${wrapWithProtectionConditionForNegationString(left)} || (${left} != "${right}")`;
    },
    renderHumanReadable: globalHumanReadableRender
  },

  'startsWith': {
    name: 'startsWith',
    displayNameKey: 'COMMON.CRM_ENTITY_OPERATORS.STARTS_WITH',
    humanReadableTranslationKey: 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.STARTS_WITH',
    renderFreeMarker(left: string, right: string) {
      return `${wrapWithProtectionConditionForString(left)} && (${left}?starts_with("${right}"))`;
    },
    renderHumanReadable: globalHumanReadableRender
  },


  'doesNotStartsWith': {
    name: 'doesNotStartsWith',
    displayNameKey: 'COMMON.CRM_ENTITY_OPERATORS.DOES_NOT_START_WITH',
    humanReadableTranslationKey: 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.DOES_NOT_START_WITH',
    renderFreeMarker(left: string, right: string) {
      return `${wrapWithProtectionConditionForNegationString(left)} || (!(${left}?starts_with("${right}")))`;
    },
    renderHumanReadable: globalHumanReadableRender
  },

  'endsWith': {
    name: 'endsWith',
    displayNameKey: 'COMMON.CRM_ENTITY_OPERATORS.ENDS_WITH',
    humanReadableTranslationKey: 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.ENDS_WITH',
    renderFreeMarker(left: string, right: string) {
      return `${wrapWithProtectionConditionForString(left)} && (${left}?ends_with("${right}"))`;
    },
    renderHumanReadable: globalHumanReadableRender
  },


  'doesNotEndWith': {
    name: 'doesNotEndWith',
    displayNameKey: 'COMMON.CRM_ENTITY_OPERATORS.DOES_NOT_END_WITH',
    humanReadableTranslationKey: 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.DOES_NOT_END_WITH',
    renderFreeMarker(left: string, right: string) {
      return `${wrapWithProtectionConditionForNegationString(left)} || (!(${left}?ends_with("${right}")))`;
    },
    renderHumanReadable: globalHumanReadableRender
  },

  'containsString': {
    name: 'containsString',
    displayNameKey: 'COMMON.CRM_ENTITY_OPERATORS.CONTAINS',
    humanReadableTranslationKey: 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.CONTAINS',
    renderFreeMarker(left: string, right: string) {
      return `${wrapWithProtectionConditionForString(left)} && (${left}?contains("${right}"))`;
    },
    renderHumanReadable: globalHumanReadableRender
  },

  'doesNotContainsString': {
    name: 'doesNotContainsString',
    displayNameKey: 'COMMON.CRM_ENTITY_OPERATORS.DOES_NOT_CONTAIN',
    humanReadableTranslationKey: 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.DOES_NOT_CONTAIN',
    renderFreeMarker(left: string, right: string) {
      return `${wrapWithProtectionConditionForNegationString(left)} || (!(${left}?contains("${right}")))`;
    },
    renderHumanReadable: globalHumanReadableRender
  },

  /***********************
   ** General Operator s**
   ***********************/
  'containsData': {
    name: 'containsData',
    displayNameKey: 'COMMON.CRM_ENTITY_OPERATORS.CONTAINS_DATA',
    humanReadableTranslationKey: 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.CONTAINS_DATA',
    renderFreeMarker: (left: string, right: string) => `(${left})?has_content`,
    renderHumanReadable: globalHumanReadableRender,
    doesNotRequireRightHandSide: true
  },

  'doesNotContainData': {
    name: 'doesNotContainData',
    displayNameKey: 'COMMON.CRM_ENTITY_OPERATORS.DOES_NOT_CONTAIN_DATA',
    humanReadableTranslationKey: 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.DOES_NOT_CONTAIN_DATA',
    renderFreeMarker: (left: string, right: string) => `(!((${left})?has_content))`,
    renderHumanReadable: globalHumanReadableRender,
    doesNotRequireRightHandSide: true
  },

  /*************************
   ** DateTime Operators  **
   *************************/
  'equalsDateTime': new DateTimeOperatorEquals(),
  'differentDateTime': new DateTimeOperatorDifferent(),
  'gtDateTime': new DateTimeOperatorGreaterThan(),
  'gteDateTime': new DateTimeOperatorGreaterOrEqualTo(),
  'ltDateTime': new DateTimeOperatorLessThan(),
  'lteDateTime': new DateTimeOperatorLessThanEqual(),
  'betweenDateTime': new DateTimeOperatorBetween(),

  /*************************
   ** Date-Only Operators  **
   *************************/
  'equalsDateOnly': new DateOnlyOperatorEquals(),
  'differentDateOnly': new DateOnlyOperatorDifferent(),
  'gtDateOnly': new DateOnlyOperatorGreaterThan(),
  'gteDateOnly': new DateOnlyOperatorGreaterOrEqualTo(),
  'ltDateOnly': new DateOnlyOperatorLessThan(),
  'lteDateOnly': new DateOnlyOperatorLessThanEqual(),
  'betweenDateOnly': new DateOnlyOperatorBetween(),

  'equalsLookup': {
    name: 'equalsLookup',
    displayNameKey: 'COMMON.CRM_ENTITY_OPERATORS.EQUALS',
    humanReadableTranslationKey: 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.EQUALS',
    renderFreeMarker: (left: string, right: ILookupData) => {
         return `${wrapWithProtectionConditionForString(left)} && (${left} == "${right.id}")`;
    },
    renderHumanReadable: function (translate: TranslateService, left: string, right: any) {
      return translate.instant(this.humanReadableTranslationKey, { leftValue: left, rightValue: right.name });
    }
  },

  'differentLookup': {
    name: 'differentLookup',
    displayNameKey: 'COMMON.CRM_ENTITY_OPERATORS.DIFFERENT',
    humanReadableTranslationKey: 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.DIFFERENT',
    renderFreeMarker: (left: string, right: ILookupData) => {
      return `${wrapWithProtectionConditionForNegationString(left)} || (${left} != "${right.id}")`;
    },
    renderHumanReadable: function (translate: TranslateService, left: string, right: ILookupData) {
      return translate.instant(this.humanReadableTranslationKey, { leftValue: left, rightValue: right.name });
    }
  },

  /****************************************
   ** List Operators (also for Boolean    **
   /****************************************/
  'equalsList': {
    name: 'equalsList',
    displayNameKey: 'COMMON.CRM_ENTITY_OPERATORS.EQUALS',
    humanReadableTranslationKey: 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.EQUALS',
    renderFreeMarker: (left: string, right: IAttributeOption) => {
      return `${wrapWithProtectionConditionForString(left)} && (${left} == "${right.value.toLowerCase()}")`;
    },
    renderHumanReadable: function (translate: TranslateService, left: string, right: IAttributeOption) {
      return translate.instant(this.humanReadableTranslationKey, { leftValue: left, rightValue: right.text });
    }
  },

  'differentList': {
    name: 'differentList',
    displayNameKey: 'COMMON.CRM_ENTITY_OPERATORS.DIFFERENT',
    humanReadableTranslationKey: 'COMMON.CRM_ENTITY_OPERATORS_HUMAN_READABLE.DIFFERENT',
    renderFreeMarker: (left: string, right: IAttributeOption) => {
      return `${wrapWithProtectionConditionForNegationString(left)} || (${left.toLowerCase()} != "${right.value.toLowerCase()}")`;
    },
    renderHumanReadable: function (translate: TranslateService, left: string, right: IAttributeOption) {
      return translate.instant(this.humanReadableTranslationKey, { leftValue: left, rightValue: right.text });
    }
  },
};

export let CrmAttributeTypeToOperatorsHash: ICrmEntityAttributeTypeToOperatorsHash = {
  'Boolean': ['equalsList', 'containsData', 'doesNotContainData'],
  'List': ['equalsList', 'differentList', 'containsData', 'doesNotContainData'],
  'TextArea': ['equalsString', 'differentString', 'containsString', 'doesNotContainsString',
    'startsWith', 'doesNotStartsWith', 'endsWith', 'doesNotEndWith', 'containsData', 'doesNotContainData'],
  'Text': ['equalsString', 'differentString', 'containsString', 'doesNotContainsString',
    'startsWith', 'doesNotStartsWith', 'endsWith', 'doesNotEndWith', 'containsData', 'doesNotContainData'],
  'Decimal': ['equalsNumber', 'differentNumber', 'lessThanNumber', 'lessOrEqualToNumber', 'greaterThanNumber', 'greaterOrEqualThanNumber', 'containsData', 'doesNotContainData'],
  'Integer': ['equalsNumber', 'differentNumber', 'lessThanNumber', 'lessOrEqualToNumber', 'greaterThanNumber', 'greaterOrEqualThanNumber', 'containsData', 'doesNotContainData'],
  'Money': ['equalsNumber', 'differentNumber', 'lessThanNumber', 'lessOrEqualToNumber', 'greaterThanNumber', 'greaterOrEqualThanNumber', 'containsData', 'doesNotContainData'],
  'DateTime': ['equalsDateTime', 'differentDateTime', 'ltDateTime', 'gtDateTime', 'betweenDateTime', 'gteDateTime', 'lteDateTime', 'containsData', 'doesNotContainData'],
  'DateTimeZoneIndependent': ['equalsDateTime', 'differentDateTime', 'ltDateTime', 'gtDateTime', 'betweenDateTime', 'gteDateTime', 'lteDateTime', 'containsData', 'doesNotContainData'],
  'DateOnly': ['equalsDateOnly', 'differentDateOnly', 'ltDateOnly', 'gtDateOnly', 'betweenDateOnly', 'lteDateOnly', 'gteDateOnly', 'containsData', 'doesNotContainData'],
  'Lookup': ['equalsLookup', 'differentLookup', 'containsData', 'doesNotContainData']
};
